import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import { NameSymbolInputComponent } from '@recruitee/symbol';
import { IconName } from '@recruitee/user-interface';
import { AnyViewSymbol, ViewLayout } from '@recruitee/views-types';

@Component({
  selector: 'rt-views-view-name-input',
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe, NameSymbolInputComponent],
  templateUrl: './view-name-input.component.html',
  styleUrls: ['./view-name-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewNameInputComponent {
  public nameControl = input.required<FormControl<string>>();
  public symbolControl = input.required<FormControl<AnyViewSymbol | null>>();
  public isViewPredefined = input<boolean>(false);
  public layoutType = input.required<ViewLayout['type']>();
  public disabled = input<boolean>(false);

  public fallbackIcon: Signal<IconName> = computed(() => {
    const symbolValue = this.symbolControl().value;
    if (this.isViewPredefined() && symbolValue?.type === 'icon') {
      return <IconName>symbolValue.name;
    }

    return 'insert-emoticon';
  });
  public errors = {
    required: this.i18n.translate('app.views.view_settings.view_name_required_error'),
  };

  constructor(private i18n: I18nService) {}
}
